import {getApi} from '../../modules/common/utils/api'

const api = getApi('audit')

export function getTemplates(params = {}) {
  return api.get(`/api/v1/audits`, {
    params: params,
  })
}

export function getTemplateAudits(params = {}) {
  return api.get(`/api/v1/audits`, {
    params: params,
  })
}

export function deleteTemplate(id) {
  return api.delete(`/api/v1/templates/${id}`)
}

export function updateTemplate(id, templateData) {
  return api.put(`/api/v1/templates/${id}`, {template: templateData})
}
